var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgEyewearImage = function SvgEyewearImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 6.5a5.508 5.508 0 00-5.229 3.803 3.125 3.125 0 00-2.542 0A5.508 5.508 0 005.5 6.5 5.506 5.506 0 000 12c0 3.033 2.467 5.5 5.5 5.5S11 15.033 11 12c0-.236-.02-.466-.049-.694a2.067 2.067 0 012.098-.001A5.587 5.587 0 0013 12c0 3.033 2.467 5.5 5.5 5.5 3.032 0 5.5-2.467 5.5-5.5s-2.468-5.5-5.5-5.5zm-13 10A4.505 4.505 0 011 12c0-2.482 2.019-4.5 4.5-4.5S10 9.518 10 12s-2.019 4.5-4.5 4.5zm13 0A4.505 4.505 0 0114 12c0-2.482 2.019-4.5 4.5-4.5S23 9.518 23 12s-2.019 4.5-4.5 4.5z",
    fill: "#767676"
  })));
};
export default SvgEyewearImage;